module.exports = __webpack_public_path__ + "static/media/GDocsPortalSiteTnC_EN.6e9244ff.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/staff_PDF/GDocsPortalSiteTnC_EN.pdf
// module id = 283
// module chunks = 4